<template>
  <modal
    max-width="80%"
    :title="`Bulk wijziging resultaat - KOM ${excelResult['KOM-nummer']} (${excelResult['KOM-jaar']})`"
    @close="closeDialog"
  >
    <div class="bulk-excel-result">
      <!-- Table with change details - same structure as BulkChangeOrderPage.vue -->
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th
                v-for="header in visibleHeaders"
                :key="header"
                :class="determineTableHeaderClass(header)"
              >
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                v-for="header in visibleHeaders"
                :key="header"
                :class="determineTableCellClass(header)"
              >
                {{ getValueForHeader(header) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="close-button">
        <app-button data-qa="close-bulk-excel-result-button" @click="closeDialog">
          {{ i18n.t('/Common/Close') }}
        </app-button>
      </div>
    </div>
  </modal>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'

export default {
  components: { Modal, AppButton },
  props: {
    excelResult: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      // All possible headers in the order they should appear (same as BulkChangeOrderPage.vue)
      allPossibleHeaders: [
        'KOM-nummer',
        'KOM-jaar',
        'Kleur',
        'Bekleding',
        'Optie(s) toevoegen',
        'Optie(s) verwijderen',
        'Sturingscode toevoegen',
        'Sturingscode verwijderen',
        'Afleverdata',
        'Owning dealer wijzigen',
        'Loslocatie',
        'EigenaarID',
        'Reserveren',
        'Blokkeren',
        'BlokkerenShowroom',
        'Commercial hold',
        'Kenteken aanvragen',
        'Kentekenplaten geel',
        'Aantal witte kentekenplaten',
        'Taxfree',
        'Order annuleren',
        'Opmerking',
        'Aanvullende bestelinformatie',
        'Wijziging succesvol',
        'Niet gewijzigd',
        'Wijziging onnodig',
      ],
    }
  },
  computed: {
    // Only show headers that have actual values - same logic as BulkChangeOrderPage.vue
    visibleHeaders() {
      return this.allPossibleHeaders.filter((header) => {
        const value = this.getValueForHeader(header)
        return value !== null && value !== undefined && value !== ''
      })
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    // Same logic as findValueByHeader in BulkChangeOrderPage.vue
    getValueForHeader(header) {
      // Handle special cases
      if (header === 'EigenaarID' && this.excelResult['EigenaarID']) {
        const kCode = this.excelResult['EigenaarID']
        if (kCode.customerCode) {
          return kCode.shouldRemove ? `${kCode.customerCode} (Te verwijderen)` : kCode.customerCode
        }
        return kCode.shouldRemove ? '(Te verwijderen)' : ''
      }

      // Return the value or empty string if not present/null
      const value = this.excelResult[header]
      return value !== null && value !== undefined ? value : ''
    },
    // Same logic as BulkChangeOrderPage.vue
    determineTableHeaderClass(header) {
      if (header === 'Wijziging succesvol') {
        return 'changeSuccessHeader'
      }
      if (header === 'Niet gewijzigd') {
        return 'changeErrorHeader'
      }
      if (header === 'Wijziging onnodig') {
        return 'changeNotNeededHeader'
      }
      return ''
    },
    // Same logic as BulkChangeOrderPage.vue
    determineTableCellClass(header) {
      // Add any specific cell classes if needed
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.bulk-excel-result {
  margin: 20px;
}

.table-container {
  margin-bottom: 20px;
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  thead {
    position: sticky;
    top: 0;
    background-color: #f4f4f4;
    z-index: 1;
  }

  thead th {
    padding: 8px;
    border: 1px solid #ddd;
    font-weight: bold;
    text-align: left;
    white-space: nowrap;
  }

  tbody td {
    padding: 8px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    word-wrap: break-word;
    max-width: 200px;
  }

  // Same color scheme as BulkChangeOrderPage.vue
  .changeSuccessHeader {
    background: rgba(0, 128, 0, 0.4);
  }

  .changeErrorHeader {
    background: rgba(255, 0, 0, 0.4);
  }

  .changeNotNeededHeader {
    background: rgba(255, 165, 0, 0.4);
  }
}

.close-button {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
